import * as React from "react"
import {TabsSeeker} from "@ui-seeker/core";

import {NOTIFICATIONS_TYPE} from "../@constants";
import {repricingNotificationsType, repricingIsLoadingNotifications} from "../@signals"


const TABS = [
	{label: 'Repricing', value: NOTIFICATIONS_TYPE.REPRICING},
	{label: 'Alerts', value: NOTIFICATIONS_TYPE.NOTIFICATION},
]

export default function RepricingNotificationsTabs() {
	return <TabsSeeker
		tabs={TABS}
		disabled={repricingIsLoadingNotifications.value}
		value={repricingNotificationsType.value}
		onChange={(_, newValue) => repricingNotificationsType.value = newValue}
	/>
}